<template>
  <page-template type="rightpanel">
    <template v-slot:toolbar>
      <tool-bar type="back-arrow" :title="prize.title ? prize.title : 'Nouveau Catalogue'" linkback="/gestion-points/catalogue"></tool-bar>
    </template>
    <template v-slot:central-panel-content>
      <div class="padding-x">
        <div>
          <v-form class="form-new-element">
            <v-container>
              <div>
                  <v-select v-model="prize.category" :items="prizeCategory" item-text="name" item-value="_id" label="Nouveau lot" :disabled="opening" outlined></v-select>
                  <v-text-field v-model="prize.title" label="Titre du lot" :disabled="opening" outlined></v-text-field>
                  <v-text-field v-model="prize.description" label="Descriptif du lot" :disabled="opening" outlined></v-text-field>
                  <v-select v-model="prize.recipients" :items="recipients" item-text="name" item-value="_id" label="Choisir les destinataires" :disabled="opening" multiple chips deletable-chips outlined></v-select>
                  <v-row class="d-flex fill-height no-gutters justify-space-between">
                    <v-col class="d-flex flex-column col-5">
                      <v-text-field v-model="prize.count" :disabled="opening" outlined label="Quantité" type="number" class="quantity">
                        <template slot="append">
                          <v-icon @click="increment">mdi-chevron-up</v-icon>
                          <v-icon @click="decrement">mdi-chevron-down</v-icon>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col class="d-flex flex-column col-5">
                      <v-text-field v-model="prize.cost" label="Points" type="number" :disabled="opening" outlined></v-text-field>
                    </v-col>
                  </v-row>
                  <div class="add-file">
                    <v-file-input v-model="newImages" type="file" @change="uploadImages()" multiple placeholder="Ajouter une photo" v-if="!opening === true" outlined dense prepend-icon=""></v-file-input>
                    <div v-for="(image, index) in images" :key="image.id" class="added-file">
                    <v-icon @click="deleteImage(index)" v-if="!opening === true">mdi-close</v-icon>
                    <img :src="image.link" alt="">
                  </div>
                </div>
              </div>
              <div v-if="!opening === true" class="d-flex justify-center">
                <v-btn @click="save(true)" class="mt-4 mx-4 primary-button">Publier</v-btn>
              </div>
            </v-container>
          </v-form>
        </div>
      </div>
    </template>
    <template v-slot:right-panel-content>
      <guide-creation
        title="Aide à la création d'un lot"
        text="Le titre doit être court. Soyez précis sur le descriptif. Les points max..."
      ></guide-creation>
    </template>
  </page-template>
</template>

<script>
  import pageTemplate from '@/templates/PageTemplate.vue'
  import toolBar from '@/components/ToolBar.vue'
  import guideCreation from '@/components/GuideCreation.vue'
  import axios from 'axios'
  import { apiURL } from '@/../config'
  export default {
    name: 'GestionPointsCatalogueNew',
    components: { pageTemplate, toolBar, guideCreation },
    props: {
      editing: {
        type: Boolean,
        default: false
      },
      opening: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        newImages: [],
        prizeCategory: [],
        recipients: [],
        images: [],
        prize: {
          category: '',
          title: '',
          description: '',
          recipients: [],
          count: 1,
          cost: '',
          images: [],
          activated: false
        }
      }
    },
    async created () {
      try {
        // PRIZE CATEGORIES
        const prizeCategoriesRes = await axios.get(`${apiURL}/data/prize/v/categories`)
        this.prizeCategory = prizeCategoriesRes.data.model
        // RECIPIENTS
        const RecipientsRes = await axios.get(`${apiURL}/data/apartments`)
        this.recipients = RecipientsRes.data.model
        // EDITING OR OPENING - GET PRIZE INFORMATION
        if (this.editing || this.opening) {
          const prizeRes = await axios.get(`${apiURL}/data/prize/${this.$route.params.id}`)
          this.prize = prizeRes.data.model
          this.prize.id = this.prize._id
          this.prize.images.forEach(e => {
            this.images.push({ id: e, link: `${apiURL}/files/render/image/${e}` })
          })
        }
      } catch (e) {
          alert('Une erreur est survenue, veuillez réessayer.')
          console.log(e)
      }
    },
    methods: {
      // INCREASE OR DECREASE QUANTITY
      increment () {
      this.prize.count = parseInt(this.prize.count, 10) + 1
      },
      decrement () {
      this.prize.count = parseInt(this.prize.count, 10) - 1
      },
      // SUBMIT IMAGE
      async uploadImages () {
        if (!this.newImages.length) return
        try {
          console.log('images to upload', this.newImages)
          this.$store.dispatch('loading')
          const formData = new FormData()
          for (let i = 0; i < this.newImages.length; i++) {
              formData.append('images', this.newImages[i])
          }
          const imageRes = await axios.post(`${apiURL}/files/upload/images`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
          imageRes.data.model.ids.forEach(e => {
              this.images.push({ id: e, link: `${apiURL}/files/render/image/${e}` })
          })
        } catch (e) {
          alert('Une erreur est survenue, veuillez réessayer.')
          console.log(e)
        } finally {
          this.newImages = []
          this.$store.dispatch('stop_loading')
        }
      },
      // DELETE IMAGE
      deleteImage (index) {
        this.images.splice(index, 1)
      },
      // PUBLISH OR EDIT NEW PRIZE
      async save (isDraft, redirect = true) {
        this.$store.dispatch('loading')
        try {
          this.prize.images = this.images.map(e => { return e.id })
          this.prize.activated = isDraft
          if (!this.editing) {
            await axios.post(`${apiURL}/manage/prize`, this.prize)
          } else {
            await axios.put(`${apiURL}/manage/prize`, { id: this.prize._id, payload: this.prize })
          }
          if (redirect) {
            this.$router.push('/gestion-points/catalogue')
          }
        } catch (e) {
          alert('Une erreur est survenue, veuillez réessayer.')
          console.log(e)
        } finally {
          this.$store.dispatch('stop_loading')
        }
      }
    }
  }
</script>